var Errors = {
    CONNECTION_LOST: 0x01,
    BOOK_ERROR: 0x02,
    SEARCH_ERROR: 0x03,
    CAN_NOT_GET_AVALIABLE_TIME: 0x04,
    CAN_NOT_GET_AVALIABLE_MANUFACTURER: 0x05,
    CAN_NOT_GET_AVALIABLE_YEAR: 0x06,
    CAN_NOT_GET_AVALIABLE_MODEL: 0x07,
    CAN_NOT_GET_AVALIABLE_TRANSMISSION: 0x08,
    CAN_NOT_GET_AVALIABLE_ENGINE: 0x09,
    CAN_NOT_GET_AVALIABLE_DRIVE_TRAIN: 0x0A
};


module.exports = Errors;    

